<button
  mat-button
  #configBtn
  class="config-btn"
  (click)="showConfigDialog()">
  <ng-container *ngIf="isCABEnabled">
    <fa-icon class="menu-item-icon" [icon]="['fas', 'function']"></fa-icon>
    Customize Budget Calculation
  </ng-container>
  
</button>
